import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/main.css";
import "react-json-pretty/themes/monikai.css";
import {Provider} from "react-redux";
import store from "./store";
import './index.css';
import { createTheme, ThemeProvider } from "@material-ui/core";

const theme = createTheme({
	palette: {
	  primary: {
		main: 'rgb(60, 141, 188)',
	  },
	  background: {
		default: '#ffffff', // Fondo blanco
		paper: '#ffffff',
	  },
	  text: {
		primary: '#000000', // Texto negro
		secondary: '#666666', // Texto gris
	  },
	},
	overrides: {
	  MuiCheckbox: {
		root: {
		  color: '#000000', // Color por defecto del checkbox
		},
		colorSecondary: {
		  '&$checked': {
			color: 'black', // Color cuando está checked
		  },
		},
	  },
	  MuiFormControlLabel: {
		root: {
		  marginBottom: 0,
		  alignItems: 'flex-start',
		},
		label: {
		  fontSize: '0.813rem',
		  color: '#000000', // Forzar color negro en labels
		},
	  },
	  MuiInput: {
		root: {
		  height: '40px', // Altura fija para inputs
		  minHeight: '40px',
		},
	  },
	  MuiSvgIcon: {
		root: {
		  color: '#000000', // Color negro para todos los iconos
		},
	  },
	},
  });

ReactDOM.render(
    <ThemeProvider theme={theme}>
		<Provider store={store}>
			<App />
		</Provider>
	</ThemeProvider>,
	//   </React.StrictMode>
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
